import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableCell(theme: Theme) {
  const commonCell = {
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    '&:not(:last-of-type)': {
      backgroundImage: `linear-gradient(${theme.palette.divider}, ${theme.palette.divider})`,
      backgroundRepeat: 'no-repeat',
      /* 1px wide, shorter than full height */
      backgroundSize: '1px calc(100% - 30px)',
      /* 16px from top, positioned at inline-end (right in LTR, left in RTL) */
      backgroundPosition: 'right 16px top 16px'
    }
  };

  return {
    MuiTableCell: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: any }) => {
          const baseStyle = {
            fontSize: '0.875rem',
            padding: 12,
            borderColor: theme.palette.divider
          };

          const align = ownerState.align;

          // Default alignment - use logical properties for RTL/LTR support
          if (!align || align === 'inherit') {
            return {
              ...baseStyle,
              textAlign: 'start',  // Automatically: left in LTR, right in RTL
              '& .MuiOutlinedInput-input': {
                textAlign: 'start'
              }
            };
          }

          if (align === 'right') {
            return {
              ...baseStyle,
              textAlign: 'end',  // Automatically: right in LTR, left in RTL
              '& .MuiOutlinedInput-input': {
                textAlign: 'end'
              }
            };
          }

          if (align === 'left') {
            return {
              ...baseStyle,
              textAlign: 'start',
              '& .MuiOutlinedInput-input': {
                textAlign: 'start'
              }
            };
          }

          if (align === 'center') {
            return {
              ...baseStyle,
              justifyContent: 'center',
              textAlign: 'center',
              '& > *': {
                justifyContent: 'center',
                margin: '0 auto'
              }
            };
          }

          return baseStyle;
        },
        sizeSmall: { padding: 8 },
        head: { fontWeight: 700, ...commonCell },
        footer: { ...commonCell }
      }
    }
  };
}
